import { Box, Card, Circle, HStack, Icon, Image, Spinner, Stack, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';
export type TransactionStepProps = {
  stepNumber: number;
  title: string;
  icon: string;
  description?: string;
  slotRight?: ReactElement;
  loading: boolean;
  complete: boolean;
  overview: ReactElement;
  slotBottom?: ReactElement;
  started: boolean;
};

const CompletionIcon = ({ complete, loading }: { complete: boolean; loading: boolean }) => {
  if (complete)
    return (
      <Icon color="#1BA27A" boxSize={6}>
        <IoCheckmarkCircle />
      </Icon>
    );
  if (loading)
    return (
      <Circle boxSize={6}>
        <Spinner />
      </Circle>
    );
  return (
    <Icon color="bg.emphasized" boxSize={6}>
      <IoCheckmarkCircle />
    </Icon>
  );
};

export const TransactionStep = ({
  stepNumber,
  icon,
  title,
  description,
  slotRight,
  loading,
  overview,
  complete,
  slotBottom,
  started,
}: TransactionStepProps) => {
  return (
    <Card.Root
      borderRadius="2xl"
      borderColor={started && !complete ? 'brandBlue' : 'border'}
      bgColor={started ? 'bg' : '#F0F3F6'}
      borderWidth={started && !complete ? 'medium' : 'thin'}
    >
      <Card.Body borderBottomWidth="thin">
        <Stack
          w="full"
          direction={['column', 'column', 'row']}
          alignItems={['flex-start', 'flex-start', 'center']}
          gap={[4, 4, 0]}
        >
          <HStack justifyContent="space-between" w={['full', 'full', 'auto']}>
            <Image boxSize={42} src={icon} mr={4} />
            <Box hideFrom="md">{slotRight}</Box>
          </HStack>
          <Box flex={2}>
            <Text fontSize="md" color="fg.muted" fontWeight="500">
              Step {stepNumber}
            </Text>

            <Text fontSize="md" fontWeight="500" h="fit-content">
              {title}
            </Text>
            {description && (
              <Text fontSize="md" fontWeight="500" h="fit-content" color="fg.muted">
                {description}
              </Text>
            )}
          </Box>
          <Box hideBelow="md">{slotRight}</Box>
        </Stack>
      </Card.Body>
      <Card.Body>
        <HStack justifyContent="space-between">
          {overview}
          <CompletionIcon complete={complete} loading={loading} />
        </HStack>
      </Card.Body>
      {slotBottom && <Card.Body borderTopWidth="thin">{slotBottom}</Card.Body>}
    </Card.Root>
  );
};
